import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ViewportAnalytics from 'components/viewport-analytics'
import ViewportController from 'components/viewport-controller'
import { component as spContext, partnersWidget } from '@cred/react-analytics/contexts'
import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import WidgetContext from 'components/widget-context'
import InitialValuesContext from 'components/initial-values-context'

const getContexts = ({
    source,
    partnerUrl,
    partnerReferrer,
    variation,
    type,
    marketplace,
    size,
    position,
    credclid,
    renderId,
    contentId,
    articleTitle,
    articleTags,
    segmentId,
    campaignCode,
    contentDistributor,
    contentCategory,
    campaignCodeExt,
  }) => {
    const spContexts = [
      partnersWidget.analytics({
        source,
        partnerUrl,
        partnerReferrer,
        widgetGeometry: { position, size },
        marketplace,
        type,
        variation,
        credclid,
        renderId,
        partnerMeta: {
          contentId,
          articleTitle,
          articleTags,
          segmentId,
          campaignCode,
          contentDistributor,
          contentCategory,
          campaignCodeExt,
        },
      }),
    ]

    return spContexts
  },
  WidgetPage = WrappedComponent => props => <HOC {...props} WrappedComponent={WrappedComponent} />,
  HOC = props => {
    const { WrappedComponent } = props,
      { initialValues } = useContext(InitialValuesContext),
      widgetContext = useContext(WidgetContext),
      {
        options: { ui: { theme }, product: { variation, type, marketplace, customCTA }, meta: { contentId, articleTitle, articleTags, segmentId, campaignCode, contentDistributor, contentCategory, campaignCodeExt } = {}, analytics, ...options },
        parentPage: { partnerReferrer, partnerDomain, partnerURL },
        credclid,
        renderId,
        source = analytics ? analytics.source : null,
      } = widgetContext,
      finalSource = source || partnerDomain
    let url = ''

    if (partnerURL) {
      [url] = partnerURL.split('?')
    }

    return (
      <ViewportController>
        {({ size, position, seen }) => (
          <SnowplowContext contexts={getContexts({
            source: finalSource,
            partnerUrl: url,
            partnerReferrer,
            variation,
            type,
            marketplace,
            size,
            position,
            credclid,
            renderId,
            contentId,
            articleTitle,
            articleTags,
            segmentId,
            campaignCode,
            contentDistributor,
            contentCategory,
            campaignCodeExt,
          })}
          >
            <ViewportAnalytics seen={seen} position={position} size={size} />
            <WrappedComponent
              {...props}
              theme={theme}
              variation={variation}
              customCTA={customCTA}
              uniqueId={options.uniqueId}
              widgetContext={widgetContext}
              initialValues={initialValues}
              verticals={marketplace}
              type={type}
              omitUtmParams={options.omitUtmParams}
              metaParams={{
                articleTitle,
                articleTags,
                contentId,
                contentCategory,
                contentDistributor,
                campaignCode,
                campaignCodeExt,
                pageUrl: partnerURL,
                segmentId,
              }}
              utms={{
                utm_campaign: url,
                utm_medium: 'partner_integration',
                utm_source: finalSource,
                utm_content: options.uniqueId || '',
                credclid,
                renderId,
              }}
              analyticsContexts={[
                spContext.analytics({ name: `${marketplace}#${type}` }),
              ]}
            />
          </SnowplowContext>
        )}
      </ViewportController>
    )
  }

HOC.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
}

export default WidgetPage
